export default {
  SET_VIEWPORT: '@SHELL_SET_VIEWPORT',
  SET_USER: '@AUTH_SET_USER',
  SIGN_OUT: '@AUTH_SIGN_OUT',

  SET_ACTIVE_USER_AD_GROUP: '@SHELL_SET_ACTIVE_USER_AD_GROUP',
  RESET_ACTIVE_USER_AD_GROUP: '@SHELL_RESET_ACTIVE_USER_AD_GROUP',
  GET_USER: '@SHELL_GET_USER',

  HIDE_GLOBAL_NAVIGATION: '@HIDE_GLOBAL_NAVIGATION',
  SHOW_GLOBAL_NAVIGATION: '@SHOW_GLOBAL_NAVIGATION',

  ADD_NOTIFICATION: '@SHELL_ADD_NOTIFICATION',
  CLEAR_NOTIFICATION: '@SHELL_CLEAR_NOTIFICATION',

  DIVISIONS_LIST_LOADING: '@SHELL_DIVISIONS_LIST_LOADING',
  DIVISIONS_LIST_SUCCESS: '@SHELL_DIVISIONS_LIST_SUCCESS',
  DIVISIONS_LIST_CLEAR: '@SHELL_DIVISIONS_LIST_CLEAR',
  DIVISIONS_LIST_ERROR: '@SHELL_DIVISIONS_LIST_ERROR',

  GET_ORDERS_ACCORDING_TO_ADVANCED_PARAMS_LOADING: '@GET_ORDERS_ACCORDING_TO_ADVANCED_PARAMS_LOADING',
  GET_ORDERS_ACCORDING_TO_ADVANCED_PARAMS_SUCCESS: '@GET_ORDERS_ACCORDING_TO_ADVANCED_PARAMS_SUCCESS',
  GET_ORDERS_ACCORDING_TO_ADVANCED_PARAMS_ERROR: '@GET_ORDERS_ACCORDING_TO_ADVANCED_PARAMS_ERROR',
  RESTORE_ORDERS_ACCORDING_TO_ADVANCED_PARAMS: '@RESTORE_ORDERS_ACCORDING_TO_ADVANCED_PARAMS',
  RESET_ORDERS_ACCORDING_TO_ADVANCED_PARAMS: '@RESET_ORDERS_ACCORDING_TO_ADVANCED_PARAMS',

  ACCOUNT_GET_ASSOCIATE_WIDGET_INFORMATION_LOADING: '@ACCOUNT_GET_ASSOCIATE_WIDGET_INFORMATION_LOADING',
  ACCOUNT_GET_ASSOCIATE_WIDGET_INFORMATION_SUCCESS: '@ACCOUNT_GET_ASSOCIATE_WIDGET_INFORMATION_SUCCESS',
  ACCOUNT_GET_ASSOCIATE_WIDGET_INFORMATION_ERROR: '@ACCOUNT_GET_ASSOCIATE_WIDGET_INFORMATION_ERROR',

  ACCOUNT_UPDATE_ASSOCIATE_WIDGET_INFORMATION_LOADING: '@ACCOUNT_UPDATE_ASSOCIATE_WIDGET_INFORMATION_LOADING',
  ACCOUNT_UPDATE_ASSOCIATE_WIDGET_INFORMATION_SUCCESS: '@ACCOUNT_UPDATE_ASSOCIATE_WIDGET_INFORMATION_SUCCESS',
  ACCOUNT_UPDATE_ASSOCIATE_WIDGET_INFORMATION_ERROR: '@ACCOUNT_UPDATE_ASSOCIATE_WIDGET_INFORMATION_ERROR',

  AUDIT_DAILY_RECEIPT_REPORT_LOADING: '@AUDIT_DAILY_RECEIPT_REPORT_LOADING',
  AUDIT_DAILY_RECEIPT_REPORT_SUCCESS: '@AUDIT_DAILY_RECEIPT_REPORT_SUCCESS',
  AUDIT_DAILY_RECEIPT_REPORT_ERROR: '@AUDIT_DAILY_RECEIPT_REPORT_ERROR',
  AUDIT_DAILY_REPORT_CLEAR: '@AUDIT_DAILY_REPORT_CLEAR',
  AUDIT_DAILY_TOTALS_REPORT_LOADING: '@AUDIT_DAILY_TOTALS_REPORT_LOADING',
  AUDIT_DAILY_TOTALS_REPORT_SUCCESS: '@AUDIT_DAILY_TOTALS_REPORT_SUCCESS',
  AUDIT_DAILY_TOTALS_REPORT_ERROR: '@AUDIT_DAILY_TOTALS_REPORT_ERROR',

  SET_STORE_NUMBER: '@SET_STORE_NUMBER',
};
